// extracted by mini-css-extract-plugin
export default {"menu":"NavBar_menu__Y0Y0Q","menuItem":"NavBar_menuItem__DVRT+","active":"NavBar_active__L6DuR"};